export default __webpack_public_path__ + "static/media/mandatumkalkulator.90586c86.png";